import { UiMessage } from "@intelligems/ig-types/schemas/ai/ui-message";

import {
  applyToTextParts,
  stripThinking,
} from "@src/features/ai/message-transform/stripThinking";

/**
 * View transform for the Experience Creation (single-agent) stream. The model
 * does all its reasoning inside a leading `<thinking>…</thinking>` scratchpad
 * and emits only a short, merchant-facing status line outside it; this strips
 * the scratchpad before display (streaming-safe — an open block is suppressed
 * through end-of-string until the closing tag lands), so the merchant sees the
 * running progress messages, not the raw model reasoning. Mirrors Viv
 * (`transformVivMessage`). Returns a converted copy — chat state is untouched.
 */
export function transformExperienceCreationMessage(
  message: UiMessage
): UiMessage {
  if (message.role === "assistant") {
    return applyToTextParts(message, stripThinking);
  }
  return message;
}
